<template>
  <div>
    <!-- search pass form  -->
    <h3>
      <span v-if="organisation">{{ organisation.name }}</span>

      <icon name="barcode" style="vertical-align:bottom;" scale="2"></icon>
    </h3>

    <div id="volume_icon" @click="changeVolume">
      <icon scale="1" v-show="audioVolume > 0" name="volume-up"></icon>
      <icon scale="1" v-show="audioVolume == 0" name="volume-off"></icon>
    </div>
    <b-row>
      <b-col cols="12" sm="8" md="4" lg="4" xl="3" class="pass-scan">
        <b-alert :show="scan.error_msg != null" variant="danger" dismissible @dismissed="scan.error_msg = null">{{
          scan.error_msg }}</b-alert>
        <b-form-group>
          <b-form-input id="pass_scan_input" v-model="scan.scan_text" size="lg" type="text"
            placeholder="Scan, enter name or phone" v-on:input="onScanInput" v-on:keyup.enter="scan_submit"
            @focus="nfcActive = false" @blur="refocusNfc">
          </b-form-input>
          <input ref="nfcInput" v-model="scanData" type="text" autocomplete="off" style="position:absolute; 
            left:-9999px;" @input="handleScan" />
          <!-- Suggestion Dropdown -->
          <b-list-group v-if="scan.suggestions.length && !scan.loading && scan.scan_text.length >= 2"
            class="suggestions-dropdown">
            <b-list-group-item v-for="(suggestion, index) in scan.suggestions" :key="index" button
              @click="selectSuggestion(suggestion)">
              {{ suggestion.pass_holder_name }} <span v-if="suggestion.phone_number">({{ suggestion.phone_number
                }})</span>
            </b-list-group-item>
          </b-list-group>


          <span class="small">Touch pass, enter barcode or search full name.</span>
        </b-form-group>
        <icon v-show="scan.loading" scale="3" id="pass_loading_sp" name="spinner" spin></icon>
      </b-col>
    </b-row>

    <!-- pass display and check-in form -->
    <b-row class="pass_container">
      <!-- pass display -->
      <b-col cols="12" sm="12" md="6" lg="6" xl="4">
        <div v-if="pass != null">
          <Pass v-bind:pass="pass" />
        </div>
      </b-col>
      <!-- check=in form -->
      <b-col cols="12" sm="12" md="6" lg="6" xl="8">
        <div id="check-in-form" v-if="pass != null">
          <h5>Check-In</h5>
          <b-alert :show="checkIn.error_msg != null" variant="danger" dismissible>{{ checkIn.error_msg }}</b-alert>
          <b-alert :show="checkIn.success" variant="success" dismissible>{{ pass.pass_holder_name }} was checked in
            successfully</b-alert>
          <b-form-group>
            <b-input-group prepend="Notes">
              <b-form-input v-model="checkIn.notes" :rows="3" :max-rows="6" type="text" @focus="nfcActive = false"
                @blur="refocusNfc">
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Check-In Type" v-if="isTravelPass">
            <b-form-radio-group id="check_in_type_radios" v-model="checkIn.check_in_type" name="radioSubComponent"
              @focus="nfcActive = false" @blur="refocusNfc">
              <b-form-radio value="lift pass">Lift Pass</b-form-radio>
              <b-form-radio value="buddy lift pass">Lift Pass (Buddy Day)</b-form-radio>
              <b-form-radio value="accommodation">Accommodation</b-form-radio>
              <b-form-radio value="lesson">Lesson</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group description="Reason for manual check-in">
            <b-form-radio-group v-if="!pass.lookup_by_rfid" v-model="checkIn.manualCheckInReason"
              @focus="nfcActive = false" @blur="refocusNfc">

              <b-form-radio value="RFID not working">RFID not working</b-form-radio>
              <b-form-radio value="Days grace">Days grace</b-form-radio>
              <b-form-radio value="Other">Other (please enter note)</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
          <b-form-group>
            <b-form-checkbox id="cbx_reroactive" v-model="checkIn.customTime" value="true" unchecked-value="false"
              @focus="nfcActive = false" @blur="refocusNfc">
              Retroactive check-in
            </b-form-checkbox>

          </b-form-group>
          <b-form-group v-if="checkIn.customTime == 'true'">
            <b-row>
              <b-col>
                Date: <b-form-input type="date" v-model="checkIn.date" :min="getCheckInMinDate"
                  :max="getCheckInMaxDate"></b-form-input>
              </b-col>
              <b-col>
                Time: <b-form-input type="time" v-model="checkIn.time"></b-form-input>
              </b-col>
            </b-row>
          </b-form-group>
          <b-form-group v-if="isAdmin">
            <b-form-select v-model="checkIn.organisation" :options="check_in_organisations.options" text-field="name"
              value-field="id" class="mb-3" ref="facilitySelect" @change="handleChange">
              <template slot="first">
                <option :value="null" disabled>-- Please select a check-in facility --</option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-button id="check_in_btn" v-focus variant="info" @click="approveCheckin">Check-In <icon scale="1"
              v-show="checkIn.loading" :disabled="pass.disabled" name="spinner" spin></icon>
            <icon scale="1" name="check"></icon>
          </b-button>
          <b-button variant="secondary" @click="hidePass">
            Cancel
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="divider"></div>
      </b-col>
    </b-row>

    <!-- Begin Activity Section -->
    <h3>Activity</h3>
    <b-form-group v-if="showModeSwitcher">
      <b-form-radio-group class="mode-toggle" button-variant="outline" v-model="currentMode" :options="modeOptions"
        buttons @focus="nfcActive = false" @blur="refocusNfc"></b-form-radio-group>
    </b-form-group>

    <b-row>
      <b-col>
        <line-chart ref="chart" v-if="show_chart" height="300" v-bind:datasets="chart_datasets"></line-chart>
      </b-col>
    </b-row>

    <!-- Filters for dashboard -->
    <b-row>
      <b-col>
        <vue-rangedate-picker class="datepicker" ref="dateRangePicker" v-bind:initRange="dateRange" i18n="EN"
          @selected="onDatesSelect" @focus="nfcActive = false" @blur="refocusNfc"></vue-rangedate-picker>
      </b-col>
      <b-col>
        <multiselect @input="refreshDisplay" class="multiselect" :multiple="true" label="name" track-by="id"
          placeholder="Pass Type" v-model="pass_types.value" :options="pass_types.options" @focus="nfcActive = false"
          @blur="refocusNfc"></multiselect>
      </b-col>
      <b-col>
        <multiselect @input="refreshDisplay" class="multiselect" :multiple="true" v-if="isAdmin" label="name"
          @focus="nfcActive = false" @blur="refocusNfc" track-by="id" placeholder="Facility"
          v-model="organisations.value" :options="organisations.options">
        </multiselect>
      </b-col>
    </b-row>

    <!-- Check In History Table -->
    <v-server-table ref="checkInTable" :columns="table_columns" :options="table_options" @loading="onLoading"
      @focus="nfcActive = false" @blur="refocusNfc" @loaded="onLoaded">
      <div slot="afterBody" v-show="loading">
        <div class="overlay-loader"></div>
        <icon scale="1" name="spinner" spin class="clip-loader"></icon>
      </div>
      <p slot="check_in_time" slot-scope="props" alt="">{{ props.row.check_in_time_formatted }}<span class="timeago">({{
        props.row.check_in_time_from_now }})</span></p>`
      <b-form-checkbox type="checkbox" v-if="isAdmin" slot="check_in_billable" slot-scope="props"
        v-model="props.row.check_in_billable" :checked="props.row.check_in_billable"
        v-on:change="toggleBillable(props.row)" @focus="nfcActive = false" @blur="refocusNfc"></b-form-checkbox>
      <span slot="controls" class="delete" slot-scope="props" @click="deleteCheckIn(props.row)">
        <icon scale="1" name="trash"></icon>
      </span>

    </v-server-table>

    <!-- csv export -->
    <b-col sm="12" v-show="!loading">
      <b-button v-on:click="saveFile()" height="30px">export
        <icon v-show="export_in_progress" scale="1" name="spinner" spin></icon>
      </b-button>

    </b-col>
    <b-col>
      <br>
      <b-alert :show="show_failed_export" variant="danger">
        An error occurred while during file export. Please contact site admins for help.
      </b-alert>
    </b-col>
    <audio id="confirm_sound">
      <source src="../assets/coins.mp3" type="audio/mp3">
    </audio>
  </div>
</template>

<script>
import Pass from "./Pass";
import api from "../api";
import LineChart from './LineChart'
import moment from 'moment'
import 'moment/locale/en-nz.js'
moment.locale('en-nz');

import VueRangedatePicker from 'vue-rangedate-picker'
import Multiselect from 'vue-multiselect'
import constants from '../constants';

var current_query = {};

// Tol's qualitative Palate
const colour_palate = ["#332288", "#6699CC", "#88CCEE", "#44AA99", "#117733", "#999933", "#DDCC77", "#661100", "#CC6677", "#AA4466", "#882255", "#AA4499"]
function loadChart(that) {
  var params = {
    startDate: that.dateRange.start.toISOString().substr(0, 10),
    endDate: that.dateRange.end.toISOString().substr(0, 10),
    passTypes: (that.pass_types.value.length ? that.pass_types.value : that.pass_types.options).map(x => x.id),
  }

  if (that.currentMode === 'ownPasses') {
    params.showManageOwnPasses = true;
  }

  if (api.userIsAdmin()) {
    params.organisations = that.organisations.value.map(x => x.id)
  }
  api.getCheckInStats(params).then(response => {
    var data = []
    var i = 0;
    for (var key in response.data.ret_msg) {
      var group_data = response.data.ret_msg[key]
      data.push({
        label: key,
        fill: false,
        backgroundColor: colour_palate[i],
        data: group_data.map(v => {
          return { x: moment(v.time), y: v.count };
        }),
      })
      i++
    }
    that.chart_datasets = data
    that.show_chart = true
  });
}

function getDefaultDateRange() {
  var end = new Date();
  end.setDate(end.getDate() + 1)
  var start = new Date();
  var day_range = 7;
  start.setDate(start.getDate() - day_range);
  return {
    start: start,
    end: end
  }
}

var defaultCheckIn = {
  notes: "",
  check_in_type: "lift pass",
  error_msg: null,
  loading: false,
  success: false,
  organisation: null,
  customTime: "false",
  time: "09:00",
  manualCheckInReason: null
}

function getDefaultCheckIn() {
  return Object.assign({}, defaultCheckIn)
}

export default {
  name: "Activity",
  components: {
    Pass,
    LineChart,
    Multiselect,
    VueRangedatePicker
  },

  async mounted() {
    this.$emit('load chart')
    this.$refs.dateRangePicker.dateRange = this.dateRange
    this.focusPassSearch();
    this.getOrganisation();

    this.searchInputEl = this.$refs.checkInTable.$el.querySelector('input[type="text"]')

    if (this.searchInputEl) {
      // Search input focus/blur control NFC mode
      this.searchInputEl.addEventListener('focus', () => {
        this.nfcActive = false
      });

      this.searchInputEl.addEventListener('blur', () => {
        this.nfcActive = true
      });
    }

    const facilitySelect = this.$refs.facilitySelect.$el;
    if (facilitySelect) {
      facilitySelect.addEventListener('focus', () => {
        this.nfcActive = false;
      });
      facilitySelect.addEventListener('change', () => {
        setTimeout(() => {
          this.refocusNfc();
        }, 100);
      });
      facilitySelect.addEventListener('blur', () => {
        setTimeout(() => {
          this.refocusNfc();
        }, 100);
      });
    }
  
    if (this.nfcActive) {
      this.$refs.nfcInput.focus();
    }
    // Only keep focus if NFC scanning mode is active
    document.addEventListener('click', () => {
      if (this.nfcActive) {
        this.$refs.nfcInput.focus()
      }
    });
    document.addEventListener('keydown', () => {
      if (this.nfcActive) {
        this.$refs.nfcInput.focus()
      }
    });
  },
  async created() {
    const currentMode = localStorage.getItem('currentMode');
    this.currentMode = currentMode || (api.canManageOwnPasses() && 'ownPasses') || 'chillPasses';

    if (!currentMode) {
      localStorage.setItem('currentMode', this.currentMode);
    }

    // Create debounced versions of methods
    this.debouncedScanSubmit = this.debounce(this.scan_submit, 100);
    this.debouncedFetchSuggestions = this.debounce(this.fetchSuggestions, 300);

    var that = this

    if (this.currentMode === 'chillPasses') {
      const response = await api.getChillPassTypes();
      that.pass_types.options = response.data.ret_msg
    } else {
      const response = await api.getAllPassTypes()
      that.pass_types.options = response.data.ret_msg
    }


    if (api.userIsAdmin()) {
      const response = await api.getAllOrganisations()
      that.organisations.options = response.data.ret_msg;
      that.check_in_organisations.options = response.data.ret_msg;
    }

    if (api.canManageOwnPasses() && !api.userIsAdmin()) {
      this.showModeSwitcher = true;
    }

    this.volumeIcon = this.getVolumeIcon
  },
  computed: {
    isTravelPass: function () {
      if (this.pass != null) {
        return /travel/i.test(this.pass.pass_type || '')
      }
      return false
    },
    getCheckInMinDate() {
      return new Date(new Date().setDate(new Date().getDate() - 120)).toISOString().substr(0, 10);
    },
    getCheckInMaxDate() {
      return new Date().toISOString().substr(0, 10)
    },
    manualCheckInReasonError() {
      if (!this.$v.checkIn.manualCheckInReason.required) {
        return 'Manual check in reason is required'
      }
    },
    notesError() {
      if (!this.$v.checkIn.notes.required) {
        return 'Notes are required';
      }
    }
  },
  data() {
    var data = {
      isAdmin: this.$parent.isAdmin,
      showModeSwitcher: false,
      currentMode: '',
      modeOptions: [
        { text: 'Chill Passes', value: 'chillPasses' },
        { text: 'Own Passes', value: 'ownPasses' }
      ],
      organisations: {
        value: [],
        options: []
      },
      check_in_organisations: {
        options: []
      },
      pass_types: {
        value: [],
        options: []
      },
      dateRange: getDefaultDateRange(),
      checkIn: getDefaultCheckIn(),
      scan: {
        scan_text: "",
        scan_text_nfc: "",
        error_msg: null,
        loading: false,
        suggestions: [],
      },
      show_chart: false,
      pass: null,
      pass_loading: false,
      checkins: {},
      organisation: null,
      nfcActive: true,
      scanData: '',
      table_columns: [
        "check_in_time",
        "pass_holder_name",
        "check_in_type",
        "pass_barcode",
        "pass_rfid",
        "pass_type_name",
        "check_in_notes",
        "staff_member",
        "manual_check_in_reason"
      ],
      chart_datasets: [],
      table_options: {
        headings: {
          pass_holder_name: "Name",
          check_in_time: "Time",
          pass_rfid: "RFID",
          pass_barcode: "Pass ID",
          org_name: "Facility",
          pass_holder_phone_number: "Phone",
          pass_type_name: "Pass Type",
          check_in_notes: "Notes",
          staff_member: "Staff Member",
          manual_check_in_reason: 'Reason'
        },
        sortable: ["barcode"],
        filterable: ["rfid", "barcode"],
        orderBy: {
          ascending: false,
          column: "time"
        },
        rowClassCallback: (row) => row.manual_check_in_reason ? 'manual-check-in' : '',
        sendInitialRequest: false,
        perPage: 25,
        perPageValues: [10, 25, 50, 100],
        requestFunction: function (data) {
          data.startDate = this.$parent.$parent.dateRange.start.toISOString().substr(0, 10)
          data.endDate = this.$parent.$parent.dateRange.end.toISOString().substr(0, 10)
          data.passTypes = (this.$parent.$parent.pass_types.value.length ? this.$parent.$parent.pass_types.value : this.$parent.$parent.pass_types.options).map(x => x.id);

          if (this.$parent.$parent.currentMode === 'ownPasses') {
            data.showManageOwnPasses = true;
          }

          if (api.userIsAdmin()) {
            data.organisations = this.$parent.$parent.organisations.value.map(x => x.id)
          }

          current_query = data;
          return api.getCheckInsByDate(data).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        responseAdapter(response) {
          var rows = response.data.ret_msg.map(v => {
            v.check_in_time_from_now = moment(v.check_in_time).fromNow()
            v.check_in_time_formatted = moment(v.check_in_time).format("DD MMM HH:mm")
            v.manual_check_in_reason = v.manual_check_in_reason
          })
          return {
            data: response.data.ret_msg,
            count:
              response.data.ret_msg.length > 0
                ? response.data.ret_msg[0].full_count
                : 0
          };
        }
      },
      loading: false,
      export_in_progress: false,
      show_failed_export: false,
      audioVolume: localStorage.getItem('audio_volume') || 0.5,
      isMtDobson: constants.isMtDobson,
      isChchGondola: constants.isChchGondola
    };
    if (api.userIsAdmin()) {
      data.table_columns.push("org_name");
      data.table_columns.push("check_in_billable");
      data.table_options.headings["org_name"] = "Facility";
      data.table_options.headings["check_in_billable"] = "Billable";
    }
    data.table_columns.push("controls");
    data.table_options.headings["controls"] = "";
    return data;
  },
  methods: {
    debounce(fn, delay) {
      let timeout
      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => fn.apply(this, args), delay)
      }
    },
    refocusNfc() {
      this.nfcActive = true
      this.$nextTick(() => {
        this.$refs.nfcInput.focus()
      })
    },
    handleScan() {
      clearTimeout(this.scanTimeout)
      this.scanTimeout = setTimeout(() => {
        const cardId = this.scanData.trim().replace(/\n|\r/g, '')
        if (cardId) {
          this.lastCard = cardId
          console.log("Scanned Card:", cardId)
          this.scan.scan_text = cardId
          // Use debounced version
          this.debouncedScanSubmit();
        }
        this.scanData = ''
      }, 150)
    },
    getVolume() {
      var volume = localStorage.getItem('audio_volume');
      return volume || 0.5;
    },
    changeVolume() {
      var vol = this.getVolume();
      var newVol = vol > 0 ? 0 : 0.5;
      localStorage.setItem('audio_volume', newVol)
      this.audioVolume = newVol;
    },
    handleChange() {
      this.nfcActive = false;
      setTimeout(() => {
        this.refocusNfc();
      }, 300);
    },
    focusPassSearch() {
      document.getElementById('pass_scan_input').focus();
    },
    onDatesSelect(dateRange) {
      this.dateRange = dateRange
      this.refreshDisplay()
    },
    refreshDisplay() {
      loadChart(this)
      this.$refs.checkInTable.refresh()
    },
    onScanInput() {
      const query = this.scan.scan_text.trim();
      if (query.length < 2) {
        this.scan.suggestions = [];
        return;
      }
      // If input looks like an RFID (7+ digits) but is not a NZ mobile number, submit immediately
      if (/^\d{6,}$/.test(query) && !/^02\d{7,9}$/.test(query)) {
        // Use debounced version
        this.debouncedScanSubmit();
        return;
      }

      // Use debounced version for suggestions
      this.debouncedFetchSuggestions(query);
    },

    async fetchSuggestions(query) {
      try {
        this.scan.loading = true;
        const response = await api.getPassByScan(query);
        this.scan.suggestions = response.data.ret_msg || [];
      } catch (e) {
        this.scan.suggestions = [];
        console.error(e);
      } finally {
        this.scan.loading = false;
      }
    },

    selectSuggestion(suggestion) {
      this.scan.scan_text = suggestion.barcode || suggestion.pass_holder_name;
      this.scan.suggestions = [];
      this.scan_submit(); // triggers the main logic immediately for selected suggestions
    },

    scan_submit(event) {
      this.pass = null;
      this.checkIn = getDefaultCheckIn()
      this.scan.loading = true
      this.scan.error_msg = null
      var scantext = this.scan.scan_text.trim();
      let self = this;

      if (scantext == "") {
        return;
      }

      // Remove the debounce wrapper here since we're already using debounced version
      api.getPassByScan(scantext)
        .then(res => {
          if (res.data.ret_msg != undefined && res.data.ret_msg.length > 0) {
            if (res.data.ret_msg.length > 1) {
              var numPasses = res.data.ret_msg.length
              var passesStr = numPasses < 5 ? res.data.ret_msg.map(x => `${x.pass_holder_name} (#${x.barcode})`).join(',') : '';
              self.scan.loading = false
              self.scan.error_msg = `Found ${numPasses} results, please make your search more specific.\n ${passesStr}`
            }

            self.pass = res.data.ret_msg[0]
            self.checkIn.success = false
            self.scan.loading = false
            self.scan.scan_text = ''
          }
        }).catch(error => {
          console.log(error);
          self.scan.loading = false
          if (error.response != undefined && error.response.status == 404) {
            self.scan.error_msg = "Pass not found: " + self.scan.scan_text
          } else {
            self.scan.error_msg = error.response.data.ret_msg || "An unknown error occurred "
          }
          self.scan.scan_text = ""
        });
    },
    approveCheckin() {
      this.checkIn.loading = true
      this.checkIn.error_msg = null
      // Ask the staff member to clip any travel passes.
      if (/travel/i.test(this.pass.pass_type) && !confirm('Have you clipped ' + this.pass.pass_holder_name + '\'s travel pass?')) {
        this.checkIn.loading = false
        return;
      }

      if (!this.pass.lookup_by_rfid) {
        if (!this.checkIn.manualCheckInReason) {
          this.checkIn.loading = false
          this.checkIn.error_msg = "Please select a reason for manually checking in this pass"
          return;
        } else if (this.checkIn.notes == "" && this.checkIn.manualCheckInReason == 'other') {
          this.checkIn.loading = false
          this.checkIn.error_msg = "Please add note explaining the reason for manual check in"
          return;
        }
      }


      if (this.checkIn.customTime == 'true' && ((this.checkIn.date || '') == '' || this.checkIn.time == '')) {
        this.checkIn.loading = false
        this.checkIn.error_msg = "Please enter a date and time"
        return;
      }

      if (this.isAdmin && !this.checkIn.organisation) {
        this.checkIn.loading = false
        this.checkIn.error_msg = "Please choose a facility"
        return;
      }

      if (this.pass.lookup_by_pass_holder_name) {
        if (!confirm('Have you verified ' + this.pass.pass_holder_name + '\'s ID?')) {
          this.checkIn.loading = false
          this.checkIn.error_msg = "Days grace check ins require ID verification"
          return;
        }
        this.checkIn.notes += ' [days grace]'
      }
      // where type is 'lift pass', 'buddy lift pass', 'accommodation', 'lesson'
      var that = this;
      api
        .checkin(
          this.pass.barcode,
          this.checkIn.check_in_type,
          this.checkIn.notes,
          this.checkIn.organisation,
          this.checkIn.customTime == 'true' ? this.checkIn.date + ' ' + this.checkIn.time : null,
          this.checkIn.manualCheckInReason
        )
        .then(response => {
          const checkInOrganisationId = response.data.check_in.organisationId;
          if (this.currentMode === 'ownPasses' && Number(api.getUserOrganisationId()) !== checkInOrganisationId) {
            this.currentMode = 'chillPasses';
          }

          that.checkIn.loading = false
          that.checkIn.success = true
          that.$emit("check-in");
          that.refreshDisplay()
          try {
            var sound = document.getElementById('confirm_sound')
            sound.volume = localStorage.getItem('audio_volume') || 0.5;
            sound.play()
          } catch (ex) { // nothing we can do if their browser does not support it
            console.log(ex)
          }
          setTimeout(() => that.pass = null, 3000);
        }).catch(error => {
          that.checkIn.loading = false
          that.checkIn.error_msg = "An unknown error occurred "
          if (error.response) {
            that.checkIn.error_msg = error.response.data.ret_msg || that.checkIn.error_msg;
          }
        })
      // Get ready for the next pass to be scanned
      this.focusPassSearch();
    },
    hidePass() {
      this.pass = null
    },
    onLoading(event) {
      this.loading = true;
    },
    onLoaded(event) {
      this.loading = false;
    },
    fillData() {
      this.dataPoints = {
        labels: ['January' + this.getRandomInt(), 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    saveFile: function () {
      var that = this
      that.export_in_progress = true

      api.getCheckInsAsCsv(current_query).then(function (result) {
        const blob = new Blob([result.data], { type: 'text/plain' })
        const e = document.createEvent('MouseEvents'),
          a = document.createElement('a');
        var curr_date_string = new Date().toISOString().replace(new RegExp("(:|\\.)", 'g'), '_')
        a.download = `chillstudio_checkin_data_${curr_date_string}.csv`;
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ['text/csv', a.download, a.href].join(':');
        e.initEvent('click', true, false);
        a.dispatchEvent(e);
        that.export_in_progress = false
      }).catch(function (error) {
        console.log(error)
        that.show_failed_export = true
        that.export_in_progress = false
      })

    },
    toggleBillable(row) {
      row.check_in_billable = !row.check_in_billable
      api.updateCheckIn(row).catch(error => { row.check_in_billable = !row.check_in_billable })
    },
    deleteCheckIn(row) {
      if (!confirm(`Are you sure you want to delete this check in for ${row.pass_holder_name}?`)) {
        return;
      }
      api.deleteCheckIn(row.pass_id, row.check_in_time).then(res => {
        row = null
        this.refreshDisplay()
      })
        .catch(error => { console.log(error) })
    },
    async getOrganisation() {
      const organisation = await api.getOrganisationById(api.getUserOrganisationId());
      this.organisation = organisation.data.ret_msg;
    }
  },
  watch: {
    async currentMode(newMode) {
      if (newMode === 'chillPasses') {
        const response = await api.getChillPassTypes();
        this.pass_types.options = response.data.ret_msg
      } else {
        const response = await api.getAllPassTypes();
        this.pass_types.options = response.data.ret_msg
      }

      this.refreshDisplay();
      localStorage.setItem('currentMode', newMode);
    }
  }
};
</script>

<style>
table {
  width: 100%;
  position: relative;
}

tr.manual-check-in {
  background: rgba(255, 230, 0, 0.349) !important;
}

.suggestions-dropdown {
  max-height: 200px;
  overflow-y: auto;
  z-index: 999;
  position: absolute;
  width: 100%;
}

.overlay-loader {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  filter: blur(5px);
}

.clip-loader {
  position: absolute;
  left: 50%;
  right: 50%;
  bottom: 60%;
  top: 40%;
  width: 60px;
  height: 60px;
}

.divider {
  border-bottom: 1px solid #ddd;
  margin: 1em 0;

}

.clip-loader {
  position: absolute;
  left: 50%;
  right: 50%;
  bottom: 60%;
  top: 40%;
  width: 60px;
  height: 60px;
}

#app .input-date {
  display: block;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.timeago {
  padding-left: 10px;
  font-size: 0.7em;
}

#pass_scan_input:focus {
  background: rgb(219, 255, 183);
}

#volume_icon {
  float: right;
  cursor: pointer;
}

.delete {
  cursor: pointer;
  color: rgb(136, 136, 136);
}

.mode-toggle {
  border: 1px solid #35A9CE !important;
  border-radius: 5px;
}

.mode-toggle .active {
  background-color: #35A9CE !important;
  border-color: #35A9CE !important;
  color: white;
}

.mode-toggle .focus {
  outline: none;
  box-shadow: none;
}

.pass-scan {
  padding-left: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/Activity.vue